import React, { Component } from 'react';
import SLinkAccount from 'shared/screens/LinkAccount';
import './LinkAccount.scss';
import ImageBW from '../../components/ImageBoundsWrapper';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { ThemeContext } from 'styled-components';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { numberWithCommas } from 'shared/utils/number';
import Button from '../../components/Button/Button';
import ModalHeader from './components/LinkAccountHeader';
import generateRender from 'shared/utils/generateRender';

const ButtonAsset = generateRender({
  default: assetSource(ASSET_KEY.CLICK_HERE_BUTTON),
  ladyluck: assetSource(ASSET_KEY.LINK_NOW_BUTTON),
});

export default class DefaultLinkAccount extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-link-account',
      hideBeforeSelector: ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'hri',
    };
  }

  handleLinkAccountClick = parentComponentMethod => async () => {
    parentComponentMethod();
    return false;
  };

  render() {
    const themeContext = this.context;

    return (
      <SLinkAccount
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { linkAccount, handleLinkAccountForm, linkedLoyaltyCardBonus } = args;

          return (
            <div style={themeContext.LinkAccount.LinkAccountContainer}>
              <ModalHeader
                title={linkAccount.linkAccountTitle}
                titleStyle={themeContext.LinkAccount.LinkAccountTitle}
                theme={themeContext.LinkAccount.LinkAccountTitle}
              />
              <img
                style={themeContext.LinkAccount.LightDividerUp}
                src={assetSource(ASSET_KEY.LIGHT_DIVIDER)}
                alt="Light Divider"
              />
              <div style={themeContext.LinkAccount.AvailableCards}>
                <ImageBW
                  source={linkAccount.icon}
                  ibw={require(asset`close-button.ibw`)}
                  manualAssetScale={3}
                  style={{
                    objectFit: 'contain',
                    height: '100%',
                    width: '100%',
                  }}
                  innerStyle={{
                    cursor: 'pointer',
                  }}
                  alt="Close"
                />
              </div>
              <img
                style={themeContext.LinkAccount.LightDividerDown}
                src={assetSource(ASSET_KEY.LIGHT_DIVIDER)}
                alt="Light Divider"
              />
              <p style={{ width: '100%', textAlign: 'center', marginBottom: '14px', fontWeight: 'bold' }}>
                {getText(TEXT_KEY.LINK_YOUR_ACCOUNT_TODAY_AND_EARN)} {numberWithCommas(linkedLoyaltyCardBonus.amount)}{' '}
                {linkedLoyaltyCardBonus.currency} {getText(TEXT_KEY.FREE_COINS_AND_BENEFITS)}
              </p>
              <ul
                style={{
                  ...themeContext.LinkAccount.Description,
                }}
              >
                {linkAccount.description.map(element => (
                  <li>{element}</li>
                ))}
              </ul>
              <Button
                imageSource={ButtonAsset}
                onClick={this.handleLinkAccountClick(handleLinkAccountForm)}
                containerStyle={themeContext.LinkAccount.LinkAccountButton}
                objectFit={'contain'}
                imageStyle={{ width: '25%' }}
              />
            </div>
          );
        }}
      />
    );
  }
}

DefaultLinkAccount.hideOverlay = true;
DefaultLinkAccount.contextType = ThemeContext;

